import { useEffect, useState } from "react";
import { Mic, Radio, Search, Headphones } from "lucide-react";

const MESSAGES = [
  "Scanning the airwaves...",
  "Tuning into frequencies...",
  "Indexing episodes...",
  "Finding the perfect conversation...",
  "Parsing RSS feeds...",
  "Listening to the noise..."
];

export function SearchingAnimation() {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % MESSAGES.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center py-16 space-y-8 min-h-[400px]">
      <div className="relative flex items-center justify-center">
        {/* Pulsing Circles */}
        <div className="absolute w-32 h-32 bg-primary/10 rounded-full animate-ping opacity-75 duration-1000" />
        <div className="absolute w-24 h-24 bg-primary/20 rounded-full animate-pulse delay-75" />
        
        {/* Central Icon */}
        <div className="relative z-10 bg-background p-4 rounded-full border border-border shadow-lg">
           <Headphones className="w-8 h-8 text-primary animate-bounce-slow" />
        </div>
        
        {/* Orbiting Icons */}
        <div className="absolute w-40 h-40 animate-spin-slow opacity-40">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -mt-2">
                <Radio className="w-4 h-4 text-muted-foreground" />
            </div>
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 -mb-2">
                <Mic className="w-4 h-4 text-muted-foreground" />
            </div>
             <div className="absolute left-0 top-1/2 -translate-y-1/2 -ml-2">
                <Search className="w-4 h-4 text-muted-foreground" />
            </div>
        </div>
      </div>

      <div className="flex flex-col items-center space-y-2 max-w-xs text-center">
        <h3 className="text-lg font-medium text-foreground animate-fade-in transition-all">
          {MESSAGES[messageIndex]}
        </h3>
        <p className="text-xs text-muted-foreground">
          This might take a moment, we're searching through millions of podcasts.
        </p>
      </div>

      {/* Waveform Bars */}
      <div className="flex items-end space-x-1 h-8">
        {[...Array(9)].map((_, i) => (
          <div
            key={i}
            className="w-1 bg-primary/60 rounded-full animate-wave"
            style={{
              animationDelay: `${i * 0.1}s`,
              height: '30%'
            }}
          />
        ))}
      </div>
      
      <style>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes wave {
          0%, 100% { height: 30%; opacity: 0.5; }
          50% { height: 100%; opacity: 1; }
        }
        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
        .animate-wave {
          animation: wave 1s ease-in-out infinite;
        }
        .animate-bounce-slow {
            animation: bounce 2s infinite;
        }
      `}</style>
    </div>
  );
}
